export default __webpack_public_path__ + "static/pro@992-022af95799e7adda87c69069f16d3b31.png";